export default "__VITE_ASSET__703e6796__"